import script from "./ClassTimetablePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassTimetablePage.vue?vue&type=script&setup=true&lang=js"

import "./ClassTimetablePage.vue?vue&type=style&index=0&id=cbd58dfa&lang=css"

const __exports__ = script;

export default __exports__